import React from "react";
import {
  SectionTitleContainer,
  SectionTitleContainer1,
  TitleText,
  TitleText1,
} from "./SectionTitle.styles";

interface Props {
  label: string;
}

const SectionTitle = ({ label }: Props) => {
  return (
    <SectionTitleContainer>
      <TitleText>{label}</TitleText>
    </SectionTitleContainer>
  );
};

export default SectionTitle;

/******************************************************************/

export const SectionTitle1 = ({ label }: Props) => {
  return (
    <SectionTitleContainer1>
      <TitleText1>{label}</TitleText1>
    </SectionTitleContainer1>
  );
};
